"use client"

import { cn } from "@/utils/classnames"
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline"
import { forwardRef, InputHTMLAttributes, useState } from "react"

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  wrapperClassName?: string
  onClickContainer?: (e: React.MouseEvent<HTMLDivElement>) => void
}

export const SearchInput = forwardRef<HTMLInputElement, InputProps>(
  ({ label, wrapperClassName, onClickContainer, ...props }, ref) => {
    return (
      <div
        onClick={e => {
          onClickContainer?.(e)
          // @ts-ignore
          ref?.current?.focus()
        }}
        className={cn(
          "relative flex h-10 w-auto cursor-pointer flex-row overflow-hidden rounded-full border border-bg-2 bg-bg-2 px-4 py-2",
          wrapperClassName
        )}>
        <span className="pr-2 sm:text-sm">
          <MagnifyingGlassIcon height={22} />
        </span>

        <input
          ref={ref}
          placeholder="Search"
          {...props}
          className={cn(
            "text-h7-lg w-full appearance-none border-none border-transparent bg-transparent p-0 outline-none focus:outline-none focus:ring-0",
            props.className
          )}
        />
      </div>
    )
  }
)

SearchInput.displayName = "SearchInput"
